import React, { useContext, useEffect } from 'react';

import Alert from '@amzn/meridian/alert';

import { useLocation } from 'react-router';
import { AppContext } from 'src/contexts/appContext';

import './TopAlert.scss';

export const TopAlert = () => {
    const { setTopAlertMsg, topAlertMsg } = useContext(AppContext);
    const { pathname } = useLocation();

    useEffect(() => {
        setTopAlertMsg('');
    }, [pathname]);

    return (
        <div className="top-alert-div">
            {topAlertMsg && (
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                <Alert type="error" onClose={() => setTopAlertMsg('')}>
                    There was an error retrieving data from the API: {topAlertMsg}
                </Alert>
            )}
        </div>
    );
};
